import React from 'react';
import { MessageCircle } from 'lucide-react';
import { COMPANY_INFO } from '../mock';

export const StickyWhatsAppButton = () => {
  return (
    <a
      href={`https://wa.me/${COMPANY_INFO.whatsapp}?text=Hallo,%20ich%20brauche%20ein%20Unfallgutachten`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] hover:bg-[#20BD5A] text-white rounded-full shadow-2xl flex items-center justify-center transition-all hover:scale-110 md:hidden"
      aria-label="WhatsApp schreiben"
    >
      <MessageCircle className="w-7 h-7" />
      <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full animate-pulse"></span>
    </a>
  );
};
